import type { Move } from "../../../../royalur/model/Move.js";
import type { Engine } from "../../../../royalur/engine/Engine.js";
import type { RoyalUrRoll } from "../../royalur/RoyalUrRoll.js";
import type { PlayerType } from "../../../../royalur/model/PlayerType.js";
import { BoardDirective } from "./BoardDirective.js";
import type { GameState } from "../../../../royalur/engine/state/GameState.js";


/**
 * A directive for rendering the dice.
 */
export class PlayBoardDirective extends BoardDirective {
    readonly activePlayer: PlayerType;
    readonly state: GameState;
    readonly roll: RoyalUrRoll | null;
    readonly availableMoves: Move[] | null;
    readonly isGameWon: boolean;

    constructor(
        directiveID: number,
        rules: Engine,
        moveIndex: number,
        activePlayer: PlayerType,
        state: GameState,
        roll: RoyalUrRoll | null,
        availableMoves: Move[] | null,
        isGameWon: boolean,
    ) {
        super(directiveID, rules, moveIndex);
        this.state = state;
        this.roll = roll;
        this.availableMoves = availableMoves;
        this.isGameWon = isGameWon;
        this.activePlayer = activePlayer;
    }

    isLimboDirective(): boolean {
        return true;
    }

    override getState(): GameState {
        return this.state;
    }

    override getActivePlayer(): PlayerType {
        return this.activePlayer;
    }
}
